import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'

function getShouldEarnLoyaltyPoints(state: App.State): boolean {
  const hasLoyaltyAccount = getHasLoyaltyAccount(state)
  const enrolAtCheckout = state.checkout.loyalty.enrolCustomerAtCheckout

  return hasLoyaltyAccount || enrolAtCheckout
}

export default getShouldEarnLoyaltyPoints
